var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg380550(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flat"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#212529",
    points: "45 17 32 25 19 17 19 3 45 3 45 17"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dd051d",
    points: "40 3 40 20.08 32 25 24 20.08 24 3 40 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,25l6.52-4-.17,0a8.22,8.22,0,0,1-1.76-1A8.12,8.12,0,0,0,32,18a8.12,8.12,0,0,0-4.59,1.91,8.22,8.22,0,0,1-1.76,1l-.17,0Z",
    fill: "#a60416"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.55,40.5c0-2.11,1.57-4.44,1-6.34S48.2,31.24,47,29.6s-1.3-4.48-3-5.69-4.35-.42-6.32-1.05S34.11,20,32,20s-3.83,2.24-5.73,2.86-4.68-.14-6.32,1.05-1.75,4-3,5.69-3.85,2.59-4.49,4.56.95,4.23.95,6.34-1.57,4.44-.95,6.34S15.8,49.76,17,51.4s1.3,4.48,3,5.69,4.35.42,6.32,1S29.89,61,32,61s3.83-2.24,5.73-2.86,4.68.14,6.32-1,1.75-4,3-5.69,3.85-2.59,4.49-4.56S50.55,42.61,50.55,40.5Z",
    fill: "#fccd1d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 40.5,
    fill: "#f9a215",
    r: 14.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.37,33l1.52,2.63a1.54,1.54,0,0,0,1.06.76L39,37a1.53,1.53,0,0,1,.85,2.56l-2.1,2.22a1.5,1.5,0,0,0-.4,1.22l.36,3a1.57,1.57,0,0,1-2.22,1.58l-2.81-1.27a1.6,1.6,0,0,0-1.32,0l-2.81,1.27A1.57,1.57,0,0,1,26.31,46l.36-3a1.5,1.5,0,0,0-.4-1.22l-2.1-2.22A1.53,1.53,0,0,1,25,37l3-.59a1.54,1.54,0,0,0,1.06-.76L30.63,33A1.59,1.59,0,0,1,33.37,33Z",
    fill: "#fccd1d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg380550);
export default __webpack_public_path__ + "static/media/svg_380550.f1394bcb366000ec1df38be8dd2e47a8.svg";
export { ForwardRef as ReactComponent };